import { Controller } from 'stimulus'
import Swiper, {Pagination} from 'swiper'
Swiper.use([Pagination])

export default class extends Controller {
  static targets = ['slider', 'pagination']

  connect() {
    this.initSlider()
  }

  initSlider() {
    new Swiper(this.sliderTarget, {
      slidesPerView: 1,
      speed: 600,
      autoHeight: true,
      centeredSlides: true,
      spaceBetween: 20,
      pagination: {
        el: this.paginationTarget,
        clickable: true,
      },
    })
  }

}
